import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

import usePageAttachmentTabs from "../Hooks/usePageAttachmentTabs";
import {
  getCaseId,
  getClientId,
  fetchShakespeareStatus,
  fetchPageObject,
  addClickRecord,
  currencyFormat,
} from "../Utils/helper";
import DatesIcon from "../assets/images/dates.svg";
import DetailIcon from "../assets/images/detail.svg";
// import TreatmentTabs from "../Components/TreatmentPage/TreatmentTabs";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import Footer from "../Components/common/footer";
// import TabsClient from "../Components/new-client-dashboard/Tabs";
import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import PageDocsTab, { createDocsTab } from "../Components/DocPage/new-tab/page-docs-tab";
// import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import addIconGold from "../assets/Add-icon-gold.svg";
import { useGetCounsels } from "../Components/CounselPage/hooks/useGetCounsel";
import TreatmentNotesSection from "../Components/TreatmentPage/NotesTreatmentSection";
import InformationPanel from "../Components/common/InformationPanel";
import ContactPanelForTreatment from "../Components/TreatmentPage/components/ContactPanelForTreatment";
import CounselEditPopup from "../Components/DefendantPage/Counsel/popups/CounselEditPopup";
import ConfirmDeletePopup from "../Components/DefendantPage/DefandantMain/ConfirmDeletePopup";
import PanelActionBarComponent from "../Components/common/PanelActionBarComponent";
import { api_without_cancellation } from "../api/api";
import CounselSummaryPage from "../Components/CounselPage/CounselSummaryPage";
import AddCounselModelCounselPage from "../Components/CounselPage/AddCounselModalCounselPage";
import PlaceHolderifNothingAdded from "../Components/components-new-final/placeholder-nothing-added";
import "../Components/common/RecordPanel.css";

function CounselPage() {
  const dispatch = useDispatch();

  // State management
  const [currentPage, setCurrentPage] = useState("all");
  const [viewType, setViewType] = useState("summary");
  const activeViewType = currentPage === "docs" ? null : viewType;

  const currentCaseId = getCaseId();
  const clientId = getClientId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (currentCaseId && !pageObject) {
      fetchPageObject(currentCaseId, 64).then((data) => {
        setPageObject(data);
      });
    }
  }, [currentCaseId, pageObject]);

  const { pathname } = useLocation();

  const URLParams = useMemo(() => {
    const numbers = pathname.match(/\d+/g);
    return numbers?.map(Number) || [];
  }, [pathname]);

  // Handlers
  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);

  const docsTabs = useMemo(
    () => [createDocsTab(() => handlePageChange("docs"))],
    [handlePageChange]
  );
  const attachmentTabs = usePageAttachmentTabs(64, docsTabs);

  const { counsels, refetch } = useGetCounsels();

  // Data fetching
  useEffect(() => {
    if (currentCaseId && clientId) {
      fetchShakespeareStatus(currentCaseId, 64, dispatch);
    }
  }, [URLParams, currentCaseId, clientId]);

  const hasAnyCounsels = counsels?.length > 0;
  const filteredCounsels = useMemo(() => {
    if (!counsels) return [];

    if (currentPage === "all" || currentPage === "photo") {
      return counsels;
    }

    if (currentPage.startsWith("client_")) {
      const clientId = parseInt(currentPage.replace("client_", ""));
      return counsels.filter(
        (insurance) => insurance?.entity_type === "Client" && insurance?.entity_obj?.id === clientId
      );
    }

    if (currentPage.startsWith("defendant_")) {
      const defendantId = parseInt(currentPage.replace("defendant_", ""));
      return counsels.filter(
        (insurance) =>
          insurance?.entity_type === "Defendant" && insurance?.entity_obj?.id === defendantId
      );
    }

    if (currentPage.startsWith("witness_")) {
      const witnessId = parseInt(currentPage.replace("witness_", ""));
      return counsels.filter(
        (insurance) =>
          insurance?.entity_type === "Witness" && insurance?.entity_obj?.id === witnessId
      );
    }

    if (currentPage.startsWith("other_")) {
      const otherId = parseInt(currentPage.replace("other_", ""));
      return counsels.filter(
        (insurance) =>
          insurance?.entity_type === "OtherParty" && insurance?.entity_obj?.id === otherId
      );
    }

    return counsels;
  }, [counsels, currentPage]);

  // Helper to check if entity has insurances
  const hasInsurancesForEntity = useCallback(
    (entityName, entityId) => {
      if (entityName === "Client") {
        return counsels?.some(
          (insurance) =>
            insurance?.entity_type === "Client" && insurance?.entity_obj?.id === entityId
        );
      }
      return counsels?.some(
        (insurance) =>
          insurance?.entity_type === entityName && insurance?.entity_obj?.id === entityId
      );
    },
    [counsels]
  );

  // Get unique entities from insurance data
  const entities = useMemo(() => {
    const clients = new Map();
    const defendants = new Map();
    const otherParties = new Map();
    const witness = new Map();

    counsels?.map((insurance) => {
      if (insurance?.entity_type === "Client") {
        // const entity = insurance?.entity_obj;

        // const name = formatInfo(entity);

        clients.set(insurance?.entity_obj?.id, {
          id: insurance?.entity_obj?.id,
          name: insurance?.entity_name,
          type: insurance?.counsel_type?.name,
        });
      }
      if (insurance?.entity_type === "Defendant") {
        // const entity = insurance?.entity_obj;

        // const name =
        //   entity?.defendantType?.id === 1 ? formatInfo(entity) : entity?.entity_name || "";

        defendants.set(insurance?.entity_obj?.id, {
          id: insurance?.entity_obj?.id,
          name: insurance?.entity_name,
          type: insurance?.counsel_type?.name,
        });
      }
      if (insurance?.entity_type === "Witness") {
        // const entity = insurance?.entity_obj;

        // const name = formatInfo2(entity);

        witness.set(insurance?.entity_obj?.id, {
          id: insurance?.entity_obj?.id,
          name: insurance?.entity_name,
          type: insurance?.counsel_type?.name,
        });
      }
      // Add to otherParties map if entity_type is "Other Party"
      if (insurance?.entity_type === "OtherParty") {
        // const entity = insurance?.entity_obj;

        // const name = formatInfo3(entity);

        otherParties.set(insurance?.entity_obj?.id, {
          id: insurance?.entity_obj?.id,
          name: insurance?.entity_name,
          type: insurance?.counsel_type?.name,
        });
      }
    });
    return {
      clients: Array.from(clients.values()),
      defendants: Array.from(defendants.values()),
      otherParties: Array.from(otherParties.values()),
      witness: Array.from(witness.values()),
    };
  }, [counsels]);
  const mainTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "all",
      label: "All",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("all"),
      leftHand: false,
    });

    entities.clients?.forEach((client) => {
      if (hasInsurancesForEntity("Client", client.id)) {
        tabs.push({
          id: `client_${client.id}`,
          label: `${client.name} - ${client?.type}`,
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`client_${client.id}`),
          leftHand: false,
          span: <i className="ic ic-19 ic-client m-r-5" />,
        });
      }
    });

    // Add individual tab for each defendant (using record_id)
    entities.defendants?.forEach((defendant) => {
      if (hasInsurancesForEntity("Defendant", defendant.id)) {
        tabs.push({
          id: `defendant_${defendant.id}`,
          label: `${defendant.name} - ${defendant?.type}`,
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`defendant_${defendant.id}`),
          leftHand: false,
          span: <i className="ic ic-19 ic-defendants m-r-5" />,
        });
      }
    });

    entities.witness?.forEach((witness) => {
      if (hasInsurancesForEntity("Witness", witness.id)) {
        tabs.push({
          id: `witness_${witness.id}`,
          label: `${witness.name} - ${witness?.type}`,
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`witness_${witness.id}`),
          leftHand: false,
          span: <i className="ic ic-19 ic-witnesses m-r-5" />,
        });
      }
    });

    // Add individual tab for each other party (using record_id)
    entities.otherParties?.forEach((party) => {
      if (hasInsurancesForEntity("OtherParty", party.id)) {
        tabs.push({
          id: `other_${party.id}`,
          label: `${party.name} - ${party?.type}`,
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`other_${party.id}`),
          leftHand: false,
          span: <i className="ic ic-19 ic-parties m-r-5" />,
        });
      }
    });

    return tabs;
  }, [handlePageChange, entities, hasInsurancesForEntity, hasAnyCounsels]);

  // Generate view tabs
  const viewTabs = useMemo(() => {
    const tabs = [];

    if (hasAnyCounsels && currentPage !== "photo") {
      tabs.push(
        {
          id: "summary",
          label: "Summary",
          className:
            activeViewType === "summary"
              ? "active tab-trapezium-cycles-corners"
              : "tab-trapezium-cycles-corners",
          background:
            activeViewType === "summary" ? "var(--primary) !important" : "var(--primary-60)",
          activeColor: "white",
          onClick: () => {
            if (currentPage === "docs") handlePageChange("all");
            setViewType("summary");
          },
          leftHand: true,
          span: (
            <span
              style={{
                width: "15px",
                height: "15px",
              }}
              className="fw-bold d-flex align-items-center justify-content-center text-gold"
            >
              <img
                src={DatesIcon}
                style={{
                  width: "15px",
                  height: "15px",
                }}
                alt="Detail"
              />
            </span>
          ),
        },
        {
          id: "detailed",
          label: "Detailed",
          className:
            activeViewType === "detailed"
              ? "active tab-trapezium-cycles-corners"
              : "tab-trapezium-cycles-corners",
          background:
            activeViewType === "detailed" ? "var(--primary) !important" : "var(--primary-60)",
          activeColor: "white",
          onClick: () => {
            if (currentPage === "docs") handlePageChange("all");
            setViewType("detailed");
          },
          leftHand: true,
          span: (
            <span
              style={{
                width: "15px",
                height: "15px",
              }}
              className="fw-bold d-flex align-items-center justify-content-center  text-gold"
            >
              <img
                src={DetailIcon}
                style={{
                  width: "15px",
                  height: "15px",
                }}
                alt="Detail"
              />
            </span>
          ),
        }
      );
    }

    return tabs;
  }, [activeViewType, hasAnyCounsels, currentPage, handlePageChange]);
  const [addCounsels, setAddCounsels] = useState(false);

  const buttonTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "insurance-add",
      label: "Counsels",
      className: addCounsels
        ? "active tab-trapezium-cycles-corners"
        : "tab-trapezium-cycles-corners",
      background: addCounsels ? "var(--primary) !important" : "var(--primary-60)",
      left: "0px",
      onClick: () => setAddCounsels(true),
      leftHand: true,
      span: (
        <span className="fw-bold  ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    });

    return tabs;
  }, [addCounsels]);

  const InsuranceButtons = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-19 ic-generate-document",
      buttonText: "Letter",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onClick: () => {},
    },
  ];

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  const getName = (type, data = {}) => {
    if (!data) return "";
    const { first_name = "", last_name = "", entity_name = "", defendantType = "" } = data;

    const fullName = `${first_name ?? ""} ${last_name ?? ""}`?.trim();

    if (type === "Defendant") {
      return defendantType?.id === 1 ? fullName : entity_name || "";
    }

    if (type === "Client") {
      return fullName;
    }
    if (type === "Witness") {
      return `${data?.witness_first_name ?? ""} ${data?.witness_last_name ?? ""}`?.trim();
    }
    if (type === "OtherParty") {
      const fullName2 = `${data?.party_first_name ?? ""} ${data?.party_last_name ?? ""}`?.trim();
      return fullName2;
    }

    return "";
  };
  const [height, setHeight] = useState(null);
  const counselRef = useRef(null);

  useEffect(() => {
    if (counselRef.current) {
      setHeight(counselRef.current.clientHeight);
    }
  }, [counselRef]);
  const [counselEditModal, setCounselEditModal] = useState(false);
  const [activeTab, setActiveTab] = useState("counsel");
  const handleCounselEditModal = (tab) => {
    setCounselEditModal(true);
    setActiveTab(tab);
  };
  const EmploymentButtonsConfig2 = [
    {
      id: "generate-document-button",
      iconClassName: "ic ic-19 m-l-5",

      imgClassName: "ic ic-19 m-r-5",
      buttonText: "",
      className: "p-l-6 p-r-5",
      style: { height: "25px" },
      onHover: () => {},
      onMouseLeave: () => {},
      onClick: () => {},
    },
  ];

  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false);

  const handleDeleteShow = () => {
    setIsShowConfirmDelete(!isShowConfirmDelete);
    addClickRecord(999, 64);
  };
  const [selectedCounsel, setSelectedCounsel] = useState(null);

  const handleDeleteCounselSubmission = async () => {
    try {
      if (!selectedCounsel) return;
      addClickRecord(999, 64);
      const response = await api_without_cancellation.delete(
        `/api/defendants/delete_opposing_counsel/${selectedCounsel?.id}`
      );
      if (response.status === 204 || response.status === 200) {
        refetch();
        setIsShowConfirmDelete(false);
        setCounselEditModal(false);
        toast.success("Delete Counsel Successfully");
      }
    } catch (error) {
      console.error("Error deleting counsel:", error);
    }
  };
  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="64" />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            <div className="d-flex flex-column w-100 " style={{ zIndex: 2 }}>
              <SmartResponsiveTabsContainer
                isEmpty={!hasAnyCounsels}
                HandlePage={currentPage}
                tabsData={mainTabs}
                viewTab={viewTabs}
                viewTabControlled={true}
                addTab={buttonTabs}
                photoTab={attachmentTabs}
                photoTabControlled={true}
                handlePageChange={handlePageChange}
                viewType={activeViewType}
              />
            </div>
            {currentPage === "docs" ? (
              <PageDocsTab
                key={`${clientId}-${currentCaseId}`}
                pageId={64}
                pageName={pageObject?.name}
                pageIcon={pageObject?.page_icon}
              />
            ) : filteredCounsels?.length === 0 ? (
              <>
                <PlaceHolderifNothingAdded
                  text1={"No Counsel added to the Case"}
                  text2={"Click to Add"}
                  pageIcon={pageObject?.page_icon}
                  onClick={() => setAddCounsels(true)}
                />
              </>
            ) : (
              <>
                {viewType === "detailed" && (
                  <div className="report mb-0">
                    {filteredCounsels?.map((co) => {
                      return (
                        <div key={co.id} className="record-panel">
                          <PanelActionBarComponent
                            compact
                            //   panelIconSrc={TitleBarImg}
                            instanceForName="Counsel"
                            page_id={64}
                            id={co?.id}
                            type={co?.counsel_type?.name}
                            name={getName(co?.entity_type, co?.entity_obj)}
                            forInstanceName={getName(co?.entity_type, co?.entity_obj) || ""}
                          />
                          <div
                            className="d-flex record-panel-body flex-wrap"
                            style={{
                              gap: "5px",
                            }}
                          >
                            <div ref={counselRef} className="leins-container-four m-b-5">
                              <div
                                className="min-w-260px-client"
                                style={
                                  {
                                    // maxHeight: "160px",
                                  }
                                }
                              >
                                <ContactPanelForTreatment
                                  id={co.opposingcounselcontact?.id}
                                  panel_name={"Law Firm"}
                                  className="m-b-0"
                                  pageName={"client"}
                                  websiteURL={co.opposingcounselcontact?.website}
                                  name={co.opposingcounselcontact?.name}
                                  address1={co.opposingcounselcontact?.address1}
                                  address2={co.opposingcounselcontact?.address2}
                                  email={co.opposingcounselcontact?.email}
                                  city={co.opposingcounselcontact?.city}
                                  state={co.opposingcounselcontact?.state}
                                  zip_code={co.opposingcounselcontact?.zip}
                                  phone_number={co.opposingcounselcontact?.phone_number}
                                  fax_number={co.opposingcounselcontact?.fax}
                                  buttonData={InsuranceButtons}
                                  genrate_doc_address={0}
                                  templateDropdownId={0}
                                  templatePageId={64}
                                  onSelectObject={() => {
                                    addClickRecord(999, 64);
                                    handleCounselEditModal("counsel");
                                    setSelectedCounsel(co);
                                  }}
                                />
                              </div>
                              <div
                                style={
                                  {
                                    // maxHeight: "160px",
                                  }
                                }
                                className="min-w-260px-client"
                              >
                                <ContactPanelForTreatment
                                  name={`${co?.supervisor?.first_name || ""} ${co?.supervisor?.last_name || ""}`}
                                  className="m-b-0"
                                  panel_name={"Supervising Attorney"}
                                  pageName="Defendants"
                                  phone_number={co?.supervisor?.phone_number}
                                  fax_number={co?.supervisor?.fax}
                                  email={co?.supervisor?.email}
                                  address1={co?.supervisor?.address1}
                                  address2={co?.supervisor?.address2}
                                  city={co?.supervisor?.city}
                                  state={co?.supervisor?.state}
                                  zip_code={co?.supervisor?.zip}
                                  ext={co?.supervisor?.phone_ext}
                                  websiteURL={co?.supervisor?.website}
                                  buttonData={InsuranceButtons}
                                  onSelectObject={() => {
                                    setSelectedCounsel(co);
                                    handleCounselEditModal("supervisor");
                                  }}
                                  genrate_doc_address={0}
                                  templateDropdownId={0}
                                  templatePageId={64}
                                />
                              </div>
                              <div
                                style={
                                  {
                                    // maxHeight: "160px",
                                  }
                                }
                                className="min-w-260px-client"
                              >
                                <ContactPanelForTreatment
                                  id={co.opposingattorney?.id}
                                  panel_name={"Main Attorney"}
                                  className="m-b-0"
                                  pageName={"client"}
                                  websiteURL={co.opposingattorney?.website}
                                  name={`${co.opposingattorney?.first_name || ""} ${co.opposingattorney?.last_name || ""}`}
                                  address1={co.opposingattorney?.address1}
                                  address2={co.opposingattorney?.address2}
                                  email={co.opposingattorney?.email}
                                  city={co.opposingattorney?.city}
                                  state={co.opposingattorney?.state}
                                  zip_code={co.opposingattorney?.zip}
                                  phone_number={co.opposingattorney?.phone_number}
                                  fax_number={co.opposingattorney?.fax}
                                  buttonData={InsuranceButtons}
                                  onSelectObject={() => {
                                    addClickRecord(999, 64);
                                    handleCounselEditModal("attorney");
                                    setSelectedCounsel(co);
                                  }}
                                  genrate_doc_address={0}
                                  templateDropdownId={0}
                                  templatePageId={64}
                                />
                              </div>
                              <div
                                style={
                                  {
                                    // maxHeight: "160px",
                                  }
                                }
                                className="min-w-260px-client"
                              >
                                <InformationPanel
                                  id={co?.id}
                                  panel_name="Information"
                                  pageName="defendant_counsel"
                                  className="m-b-0"
                                  data={[
                                    { label: "Type", value: co?.counsel_type?.name },
                                    { label: "File", value: co?.file_number },
                                    {
                                      label: "Original Lien",
                                      value: currencyFormat(co?.orignal_lien),
                                    },
                                    { label: "Final Lien", value: currencyFormat(co?.final_lien) },
                                  ]}
                                  onSelectReport={() => {
                                    addClickRecord(999, 64);
                                    handleCounselEditModal("information");
                                    setSelectedCounsel(co);
                                  }}
                                  hasBtn={true}
                                  buttonData={EmploymentButtonsConfig2}
                                  panelClassName="mt-0"
                                  // defaultLength={7}
                                />
                              </div>
                            </div>

                            <div
                              className=""
                              style={{
                                flex: 1,
                                minHeight: "160px",
                                paddingRight: "0px",
                                scrollbarWidth: "none",
                                minWidth: "min(400px, 100%)",
                                maxHeight: `${height}px`,
                              }}
                            >
                              <p className="menu-bar-style columnsTitle text-center">Notes</p>
                              <TreatmentNotesSection
                                entity_type={"Counsel"}
                                record_id={co?.id}
                                module={"Counsel"}
                                notesName={"Counsel"}
                                instanceFor="Defendants" //to show height with respect to defendants page
                                pagePanels={4}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                {viewType === "summary" && (
                  <>
                    <CounselSummaryPage insurances={filteredCounsels} />
                  </>
                )}
              </>
            )}
            <div
              className="invisible-scrollbar h-100"
              style={{ overflowX: "hidden", overflowY: "scroll", marginTop: "0px" }}
            >
              <NotesSectionDashboard pageName={"Counsel"} />
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {counselEditModal && (
        <CounselEditPopup
          show={counselEditModal}
          handleClose={() => {
            addClickRecord(999, 64);
            setCounselEditModal(false);
          }}
          activeTab={activeTab}
          pageName={null}
          handleFacthDefendants={refetch}
          onShowDeleteConfirmPopup={handleDeleteShow}
          opposingcounsel={selectedCounsel}
        />
      )}
      {isShowConfirmDelete && (
        <ConfirmDeletePopup
          entity="Counsel"
          handleClose={handleDeleteShow}
          handleDeleteSubmission={handleDeleteCounselSubmission}
        />
      )}

      {addCounsels && (
        <AddCounselModelCounselPage
          handleClose={() => {
            addClickRecord(999, 2);
            setAddCounsels(false);
          }}
          show={addCounsels}
          refetch={refetch}
        />
      )}
    </>
  );
}

export default CounselPage;
